import { dispatch, getState } from '../..';
import { IValueAddedTax } from '../../../@types/model/masterData/valueAddedTax/valueAddedTax';
import ValueAddedTaxModelHelper from '../../../@types/model/masterData/valueAddedTax/valueAddedTaxModelHelper';
import GeneralFunctions from '../../general/functions';
import MasterDataValueAddedTaxActions from './actions';

export default class MasterDataValueAddedTaxFunctions {
    private static listener : undefined | (() => void);


    public static readonly load = async () => {
        if (MasterDataValueAddedTaxFunctions.listener) return;
        
        dispatch(MasterDataValueAddedTaxActions.setLoading(true));
        dispatch(MasterDataValueAddedTaxActions.set([]));

        try {
            MasterDataValueAddedTaxFunctions.listener = ValueAddedTaxModelHelper.collection().onSnapshot((snapshot : firebase.firestore.QuerySnapshot<IValueAddedTax>) => {
                const state = getState().masterData.valueAddedTax;

                const list = state.valueAddedTaxes.slice();
            
                const session = getState().auth.session;
                if (!session) return;

                // "added" | "removed" | "modified"
                snapshot.docChanges().forEach((x) => {
                    const item = x.doc.data();
                    const index = list.findIndex(n => n.guid === item.guid);

                    switch (x.type) {
                        case 'added':
                            list.push(item);
                            break;
                        case 'modified':
                            list.splice(index, 1, item);
                            break;
                        case 'removed':
                            list.splice(index, 1);
                            break;
                    }
                });

                dispatch(MasterDataValueAddedTaxActions.set(list));
                dispatch(MasterDataValueAddedTaxActions.setLoading(false));
            }, (ex) => {
                GeneralFunctions.generalShowError(ex, 'Error loading value added taxes.');
                dispatch(MasterDataValueAddedTaxActions.setLoading(false));
            }, () => {
                dispatch(MasterDataValueAddedTaxActions.setLoading(false));
                MasterDataValueAddedTaxFunctions.listener = undefined;
            });

        } catch (ex) {
            GeneralFunctions.generalShowError(ex, 'Error loading value added taxes.');
            dispatch(MasterDataValueAddedTaxActions.setLoading(false));
        }
    };
}